import { render, staticRenderFns } from "./solicitacao-fornecedor.vue?vue&type=template&id=788f0b24"
import script from "./solicitacao-fornecedor.vue?vue&type=script&lang=js"
export * from "./solicitacao-fornecedor.vue?vue&type=script&lang=js"
import style0 from "./solicitacao-fornecedor.vue?vue&type=style&index=0&id=788f0b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports